module.exports = __webpack_public_path__ + "json/market2-0.json?339d8be30172205300e864cd56800d33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market2-0.json
// module id = 1262
// module chunks = 3